import React from 'react'
import { connect } from 'react-redux'
import withSiteContext from 'layers/content/v2/Hocs/withSiteContextLegacy'
import { RouteContentGetter } from 'layers/content/v2/Hocs/RouteContentGetter'
import { resolveRouteServiceApp } from 'utils/productHelpers'
import {
  transformInstructorDataToOldShape,
  isPreviewMode,
} from 'utils/highschoolHelpers'
import withApiError from 'layers/errorHandling/apiError'
import { navigationEvent } from 'layers/navigation/store/operations'
import { selectors as lmsSelectors } from 'store/lmsManager'

import HighSchoolTrainingLandingComponent from './component'

const HighSchoolTrainingLandingContainer = props => {
  const { match, routeContent, instructorData, productTabTitle } = props || {}

  const { content = {}, loading } = routeContent
  // instructorData is only used to tell us if we've completed trainings (not applicable for preview mode)
  const hasNeededInstructorData = isPreviewMode() || !!instructorData
  const readyToLoad = !!content && !loading && hasNeededInstructorData

  return (
    readyToLoad && (
      <HighSchoolTrainingLandingComponent
        content={content}
        instructorData={instructorData}
        match={match}
        productTabTitle={productTabTitle}
      />
    )
  )
}

const options = {
  app: ({ route }) => resolveRouteServiceApp(route),
}

const mapDispatchToProps = {
  navigationEvent,
}

const mapStateToProps = state => ({
  productTabTitle: state.productManager?.productMap?.name || '',
  instructorData: transformInstructorDataToOldShape(
    lmsSelectors.selectHsInstructorData(state),
  ),
})

const HydratedComponent = connect(
  mapStateToProps,
  mapDispatchToProps,
)(HighSchoolTrainingLandingContainer)

export default RouteContentGetter(
  withSiteContext(withApiError(HydratedComponent), { useGuard: true }),
  options,
)
